export default "__VITE_ASSET__DjSDYmWU__"